<template>
    <div>
        <div class="row mt-3">
            <div class="col-md-6">
                <strong>Technician:</strong><br>
                <input placeholder="Name" name="technicians[0][name]"
                       :value="items[0] ? items[0].name : ''"
                       class="form-control">
                <input placeholder="Phone" name="technicians[0][cell]" :value="items[0] ? items[0].cell : ''"
                       class="form-control">
                <input placeholder="Email" name="technicians[0][email]" :value="items[0] ? items[0].email : ''"
                       class="form-control">
            </div>
            <div class="col-md-6">
                <br>
                <input placeholder="License/Cert #" name="technicians[0][license]"
                       :value="items[0] ? items[0].license : ''"
                       class="form-control license">
            </div>
        </div>
        <div class="row">
            <div :class="{'col-md-8': isMobile, 'col-md-12': !isMobile}" class="mt-2 mb-5">
                <label
                    for="technician_signature">Technician Signature</label>
                <m-signature ref="technician_signature" height="140px" :width="`${$root.signatureWidth}`"
                             name="technician_signature"
                             :value="technicianSignature"></m-signature>
            </div>
            <div class="col-md-12 ml-3" id="technician_signature_error"></div>

        </div>
        <strong>Other Technicians :</strong><br>
        <table class="table table-responsive table-striped table-bordered d-table mt-3">
            <thead>
            <tr>
                <td>Name</td>
                <td style="width: 20%;">License/Cert #</td>
                <td style="width:5%">Delete</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, itemIndex) in items.slice(1)" :key="itemIndex">
                <td>
                    <input :name="'technicians['+(itemIndex + 1)+'][name]'"
                           v-model="item.name"
                           class="form-control form-report time"/>
                </td>
                <td>
                    <input :name="'technicians['+ (itemIndex + 1)  +'][license]'"
                           v-model="item.license"
                           placeholder="License/Cert #"
                           class="form-control form-report time"/>
                </td>
                <td><a @click="deleteLine(item.id || null, (itemIndex + 1))" title="Delete"
                       class="btn btn-danger text-white"><span
                    class="fa fa-trash"></span></a></td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <th colspan="9">
                    <button @click="addLine()" type="button"
                            class="btn btn-sm"
                            data-toggle="tooltip"
                            data-original-title="Add more lines">
                        <i class="fa fa-plus"></i>
                    </button>

                </th>

            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import draggable from 'vuedraggable'
import {mask} from 'vue-the-mask'
import WorkTicketStaffModel from "../../../models/WorkTicketStaffModel";
import MSignature from "../../generics/MSignature.vue";

export default {
    name: "WorkTicketTechniciansComponent",
    components: {MSignature},
    props: {
        technicians: {
            type: Array,
            required: true
        },
        technicianSignature: {
            required: false
        },
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            items: [],
        }
    },
    mounted() {
        if (this.technicians && this.technicians.length > 0) {
            this.items = this.technicians
        }
    },
    methods: {
        addLine() {
            let item = {}
            this.items.push(item);
        },
        deleteLine(id, itemIndex) {
            this.items.splice(itemIndex, 1);
        },
    }
}
</script>

<style scoped>
</style>
